module.exports = new __parcel__URL__("mail.fa9e5422.png").toString();